import React from 'react'
import './InitialLoader.css'

export default () => (
  <div className="initial-loader">
    <div className="lds-ripple"><div></div><div></div></div>
  </div>
)